import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Router } from '@angular/router';
import { RetailerDto, RetailerBrandsListItemDto, RetailerProfileDocDto } from '../dtos/retailers.model';
import { Subject } from 'rxjs';
import { PlanData } from '../dtos/programs.model';
import { RetailerProfileModel } from '../dtos/retailer-profile';

@Injectable()
export class RetailerService {
    public newRetailerAdded: Subject<any>;
    public retailerProfileDocAdded: Subject<any>;
    public budgetYear: number;
    public retailerId: number;
    public categoryId: number;

    constructor(private apiService: ApiService,
       private router: Router) {
        this.newRetailerAdded = new Subject<any>();
        this.retailerProfileDocAdded = new Subject<any>();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getRetailers(params?: any): Observable<ApiResponse<ApiPagedResponse<RetailerDto>>> {
        console.log('>>getRetailers', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<RetailerDto>>('retailers', params);
    }

    getRetailerBudgetYearBrands(retailerId: number, fiscalYear: number, extraParams?: any): Observable<ApiResponse<PlanData[]>> {
        console.log('retailerId', retailerId);
        console.log('fiscalYear', fiscalYear);

        console.log('>>getRetailerBudgetYearBrands');
        const params = { budgetYear: fiscalYear, retailerId: retailerId, pageSize: 100000, pageIndex: 0 };
        return this.apiService.get<PlanData[]>(`retailers/${retailerId}/brands`, {
            ...extraParams,
            ...(params || {})
        });
    }

    getRetailer(id) {
        return this.apiService.get(`retailers/edit/${id}`);
    }

    saveRetailer(params?: RetailerDto) {
        if (params.id && params.id > 0) {
            return this.apiService.put(`retailers`, params);
        } else {
            return this.apiService.post(`retailers`, params);
        }
    }

    getAccountLocations(params?: any): Observable<ApiResponse<ApiPagedResponse<RetailerDto>>> {
        console.log('>>getAccountLocations', JSON.stringify(params));
        return this.apiService.get<ApiPagedResponse<RetailerDto>>('account-location/lookup', params);
    }

    getSummary(params?: any): Observable<ApiResponse<ApiPagedResponse<any>>> {
        return this.apiService.get<ApiPagedResponse<any>>('retailers/summary', params);
    }

    getActiveRetailers(params?: any): Observable<ApiResponse<any>> {
        console.log('>>getRetailers', JSON.stringify(params));
        return this.apiService.get<RetailerDto>('retailers/active?', params);
    }

    getPagedActiveRetailers(params?: any): Observable<ApiResponse<any>> {
        console.log('>>getRetailers', JSON.stringify(params));
        return this.apiService.get<RetailerDto>('retailers/active-paged?', params);
    }

    updateFlags(params?: any) {
        return this.apiService.post(`retailers/update-flags`, params);
    }

    getRetailerProfile(params?: any): Observable<ApiResponse<string>> {
        console.log('>>getRetailers', JSON.stringify(params));
        return this.apiService.get<string>('retailers/profile', params);
    }

    getOwnerResidents(params?: any): Observable<ApiResponse<{id, config, data}>> {
        console.log('>>getRetailers', JSON.stringify(params));
        return this.apiService.get<{id, config, data}>('retailers/owners', params);
    }

    getDocs(id?: any): Observable<ApiResponse<RetailerProfileDocDto[]>> {
        return this.apiService.get<RetailerProfileDocDto[]>(`retailers/lib/${id}`, {});
    }

    copyDoc(params: RetailerProfileDocDto): Observable<ApiResponse<RetailerProfileDocDto[]>> {
        return this.apiService.post<RetailerProfileDocDto[]>(`retailers/lib/copy`, params);
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/retailer.service.ts